export default __webpack_public_path__ + "static/media/73t.98720d64.jpg";